import { render, staticRenderFns } from "./QualityAssurance.vue?vue&type=template&id=6c7d3f08&scoped=true&"
import script from "./QualityAssurance.vue?vue&type=script&lang=js&"
export * from "./QualityAssurance.vue?vue&type=script&lang=js&"
import style0 from "./QualityAssurance.vue?vue&type=style&index=0&id=6c7d3f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d3f08",
  null
  
)

export default component.exports